import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/GoshalaGold(Golden).png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const GoshalaGold = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    {
      nutrient: "Protein",
      value: "20%",
      comment: "Supports muscle growth and milk production.",
    },
    {
      nutrient: "Fat",
      value: "3%",
      comment:
        "Provides a steady source of energy for daily activities and lactation.",
    },
    {
      nutrient: "Fiber",
      value: "11%",
      comment: "Enhances digestion and promotes a healthy gut.",
    },
    {
      nutrient: "Moisture",
      value: "11%",
      comment: "Ensures freshness and palatability.",
    },
    {
      nutrient: "Insoluble Matter",
      value: "3%",
      comment: "Guarantees purity and digestibility of the feed.",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div className={isMobile ? "product-image product-image--mobile" : "product-image"}>
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">GAUSHALA GOLD </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p>
                Gaushala Gold (TYPE - 2) is a nutritionally balanced cattle
                feed, designed to support the health and productivity of dairy
                and farm animals. Formulated with an optimal blend of protein,
                fat, fiber, and essential nutrients, it ensures that your cattle
                receive the vital nutrition they need for sustained energy,
                healthy growth, and efficient milk production. Whether your
                livestock are for milk production or general farming, Gaushala
                Gold provides them with the nutrients needed for overall
                well-being.
              </p>
              <p>
                Gaushala Gold is the perfect choice for farmers looking to
                provide their cattle with a nutritious, balanced feed that
                promotes growth, health, and milk production. It's a reliable
                solution for keeping livestock healthy, strong, and productive.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Boosts Milk Production: </b> With a 20% protein content,
                    Gaushala Gold supports optimal milk yield, helping dairy
                    cattle stay productive while ensuring muscle growth and
                    development.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Enhanced Digestive Health: </b>The 11% fiber content
                    improves digestive function, aiding in nutrient absorption
                    and reducing the risk of digestive issues in cattle, which
                    leads to healthier, more efficient livestock.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Steady Energy Levels: </b>The 3% fat content provides a
                    balanced energy source, helping cows stay active and
                    productive throughout the day without overloading their
                    system.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Freshness and Palatability: </b>With an 11% moisture
                    content, Gaushala Gold stays fresh, ensuring that your
                    cattle consistently consume the required nutrients with
                    every feed.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Balanced Nutrition: </b>Formulated to maintain a clean
                    and digestible feed, Gaushala Gold's composition of low
                    insoluble matter (max 3%) guarantees purity, making sure
                    your livestock receive all the essential nutrients without
                    unnecessary fillers.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable isCommentPresent={true} data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Gaushala-gold-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default GoshalaGold;
